<template>
  <div class="container-fluid bg-light py-5 about-section">
    <div class="container text-center">
      <h2 class="about-us-title text-orange fw-bold">Welcome to our world, where dreams, beauty, and practicality come together to create an unforgettable travel experience.
      </h2>
      
      
    </div>

    <div class="container py-5">
      <div class="row align-items-center">
        <!-- Left Section: Text -->
        <div class="col-md-6">
          <div class="text-content">
            
            
            <p>Alireza Keimanesh founded the company in 2019, bringing over twenty years of experience in the Italian tourism industry.</p>
            <p>He first moved to Italy to study at the Academy of Fine Arts of Rome, where he earned a BA and an MA in Arts, specializing in Decoration.</p>
            <p>Drawn to the architectural wonders and local culture, he started working in tourism, guiding groups of travelers to uncover the treasures of Italy’s most beautiful cities—especially Rome, where he chose to settle.</p>
            <p>Leading tours on <span class="text-orange"> Segways</span>, <span class="text-orange">Golf Carts</span>, and <span class="text-orange">Vintage Fiat 500s</span>, he shares his extensive knowledge of the city, which he knows like the back of his hand. </p>
            <p>Mr. Keimanesh has guided thousands of curious travelers through the Eternal City, showcasing its iconic attractions and hidden gems.</p>
            <p>His passion for timelessly beautiful vintage cars, such as the FIAT 500, and electric vehicles drives his meticulous efforts to ensure the fleet’s efficiency and safety.</p>
            <p><router-link to="/contact" class="text-orange fw-bold">Get in touch </router-link>to rent one of our vehicles or join a guided city tour. You choose the ride, and we’ll plan the perfect itinerary!</p>
            <router-link to="/services" class="btn btn-orange mt-3">Explore Services</router-link>
          </div>
        </div>
        
        <!-- Right Section: Image and Additional Text -->
        <div class="col-md-6 text-center pl-2">
          <div class="manager-photo mb-3">
            <img :src="require('@/assets/images/poyan1.jpg')" alt="Manager Photo" class="rounded-circle shadow-lg img-fluid">
            <p class="fw-bold mt-2">Our Founder and Manager: Alireza Keimanesh</p>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.text-content {
  text-align: justify;
}

.about-us-title {
  font-size: 2rem;
}

.text-orange {
  color: #f26522;
}

.btn-orange {
  background-color: #f26522;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  text-decoration: none;
}

.btn-orange:hover {
  background-color: #d3541f;
}
.about-section {
  color: #111; 
}

</style>
